import {useSelector, shallowEqual} from 'react-redux';
import {
  useAutoFocus as useSharedAutoFocus,
  useNavigationFocus as useSharedNavigationFocus,
} from '../../../hooks/useAutoFocus';
import {setScanPackMainInputFocus, focusMainInputUnlessHandoff} from '../../../actions/scanpackScanningActions';
import {v2FocusBlockingModalOpen} from '../../scanpack/boxChampModalFlags';
import {useBoxChampGuided} from './useBoxChampGuided';

const selectFocusState = (state) => ({
  mainInputHasFocus: state.scanPackScanning.mainInputHasFocus,
  overlayOpen: v2FocusBlockingModalOpen(state),
});

const useAutoFocus = (delay = 1000) => {
  const {mainInputHasFocus, overlayOpen} = useSelector(selectFocusState, shallowEqual);
  const {ownsFocus: handoffOwnsFocus} = useBoxChampGuided();

  const isAnyPromptOpen = overlayOpen || handoffOwnsFocus;

  return useSharedAutoFocus({
    mainInputHasFocus,
    isAnyPromptOpen,
    setFocusAction: setScanPackMainInputFocus,
    delay,
  });
};

export const useNavigationFocus = () =>
  useSharedNavigationFocus(focusMainInputUnlessHandoff);

export default useAutoFocus;
